import React from 'react';
import { get } from 'lodash';
import { TopScoreBoxNewReport } from 'src/pagesDashboard/NewUserReport/components';
import { useReportScore } from 'src/queries/reports';
import { getAvgSentimentLabel } from 'common/commonNlpUtils';

const TopScores = ({ reportId }) => {
  const {
    data: reportScore,
    isFetching: isFetchingReportScore,
    isError: isErrorReportScore
  } = useReportScore(reportId, { include: { previousReportScore: true } });

  const isFetching = isFetchingReportScore;
  const isError = isErrorReportScore;
  const isReady = !isFetching && !isError;

  if (!isReady) return <div />;

  const previousReportScore = get(reportScore, 'previousReportScore');

  const avgScoreReceived = get(reportScore, 'avgScoreReceived');
  const avgSentimentReceived = get(reportScore, 'avgSentimentReceived');
  const reviewedReceivedCount = get(reportScore, 'reviewedReceivedCount');
  const naReceivedCount = get(reportScore, 'naReceivedCount');
  const avgScoreLabel = get(reportScore, 'avgScoreLabel');
  const avgSentimentLabel = getAvgSentimentLabel(avgSentimentReceived);

  const previousAvgScoreReceived = get(previousReportScore, 'avgScoreReceived');
  const previousAvgSentimentReceived = get(
    previousReportScore,
    'avgSentimentReceived'
  );
  const previousReviewedReceivedCount = get(
    previousReportScore,
    'reviewedReceivedCount'
  );
  const previousNaReceivedCount = get(previousReportScore, 'naReceivedCount');
  const previousAvgScoreLabel = get(previousReportScore, 'avgScoreLabel');
  const previousAvgSentimentLabel = getAvgSentimentLabel(
    previousAvgSentimentReceived
  );

  const feedbackResponses = parseInt(reviewedReceivedCount, 10) + parseInt(naReceivedCount, 10);
  const previousFeedbackResponses = parseInt(previousReviewedReceivedCount, 10)
    + parseInt(previousNaReceivedCount, 10);

  return (
    <div className='flex flex-row justify-center 2xl:justify-between flex-nowrap max-lg:flex-wrap gap-2 m-0 mb-4'>
      <TopScoreBoxNewReport
        title='Performance Score'
        subtitle='This team member’s overall performance (out of 100) based on their reviews.'
        score={{
          value: avgScoreReceived,
          label: avgScoreLabel
        }}
        previousScore={{
          value: previousAvgScoreReceived,
          label: previousAvgScoreLabel
        }}
        // tooltip='Performance Score'
        loading={false}
      />

      <TopScoreBoxNewReport
        title='Feedback Responses'
        subtitle='Number of feedback responses included in this report based on the designated date range.'
        score={{
          value: feedbackResponses
        }}
        previousScore={{
          value: previousFeedbackResponses
        }}
        // tooltip='Reviews Received'
        loading={false}
      />

      <TopScoreBoxNewReport
        title='Sentiment Score'
        subtitle='How positive or negative the feedback is for this team member (-100 to +100).'
        score={{
          value: avgSentimentReceived,
          label:
            avgSentimentReceived !== avgSentimentLabel
              ? avgSentimentLabel
              : null
        }}
        previousScore={{
          value: previousAvgSentimentReceived,
          label:
            previousAvgSentimentReceived !== previousAvgSentimentLabel
              ? previousAvgSentimentLabel
              : null
        }}
        // tooltip='Sentiment Score'
        loading={false}
      />
    </div>
  );
};

export default TopScores;
